export enum RoutePages {
  Root = '',
  MainEnvelope = 'main-envelope',
  NewEnvelope = 'new-envelope',
  SentEnvelope = 'sent-envelope',
  InboxEnvelope = 'inbox-envelope',
  Settings = 'settings',
  Signature = 'signature',
  Suite = 'suite',
  VerificationPortal = 'verification-portal',
  Reports = 'reports',
  Contacts = 'contacts',
  FeedbackPortal = 'feedback-portal',
  EditEnvelope = 'edit-envelope',
  Dashboard = 'dashboard',
  PaidDashboard = 'paid-dashboard',
  VerificationPortalDocument = 'verification-portal-document'
}
